import styled, { css } from 'styled-components';

export const PremiumUnit = styled.div`
  color: var(--grey700);
  text-align: right;
  font-feature-settings: 'clig' off, 'liga' off;
  /* 12px/regular */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  ${(props) =>
    !!props.gap &&
    css`
      gap: ${props.gap};
    `};
`;
